import { ComponentConfigProps, FilterData } from "../typing";
import FilterItemAirlines from "./Airlines";
import FilterItemBanks from "./Banks";
import FilterItemCabins from "./Cabins";
import FilterItemCategory from "./Category";
import FilterItemLastSeenTime from "./LastSeenTime";
import FilterItemMaxPoints from "./MaxPoints";
import FilterItemNonStop from "./NonStop";
import FilterItemPremium from "./Premium";
import FilterItemPrograms from "./Programs";
import FilterItemSeats from "./Seats";
import FilterItemTax from "./Tax";

/**
 * 注册的filter项目
 */
export const filterRegisterList: ComponentConfigProps[] = [
  {
    key: "programs",
    label: "Programs",
    component: FilterItemPrograms,
    defaultValue: [],
  },
  {
    key: "banks",
    label: "Cards",
    component: FilterItemBanks,
    defaultValue: [],
  },
  {
    key: "seats",
    label: "Seats",
    component: FilterItemSeats,
    defaultValue: [1, 1, 1, 1],
  },
  {
    key: "maxPoints",
    label: "Max Points",
    component: FilterItemMaxPoints,
    defaultValue: [-1, -1, -1, -1],
  },
  {
    key: "cabins",
    label: "Cabin Class",
    component: FilterItemCabins,
    defaultValue: [],
  },
  {
    key: "nonStop",
    label: "Stops",
    component: FilterItemNonStop,
    defaultValue: [],
  },
  {
    key: "airlines",
    label: "Airlines",
    component: FilterItemAirlines,
    defaultValue: [],
  },
  {
    key: "premium",
    label: "Premium Cabin %",
    component: FilterItemPremium,
    defaultValue: [0, 0],
  },
  {
    key: "tax",
    label: "Tax",
    component: FilterItemTax,
    defaultValue: -1,
  },
  {
    key: "category",
    label: "Category",
    component: FilterItemCategory,
    defaultValue: [],
  },
  {
    key: "lastSeenTime",
    label: "Last Seen",
    component: FilterItemLastSeenTime,
    defaultValue: -1,
  },
];

/**
 * 获取所有filter的默认值
 * @returns
 */
export const getFilterDefault = () => {
  return filterRegisterList.reduce(
    (result, item) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      result[item.key] = item.defaultValue;
      return result;
    },
    {
      excludeAirlines: [] as string[],
    } as FilterData
  );
};

export const getFilterConfigByKey = (key: string): ComponentConfigProps | undefined => {
  return filterRegisterList.find((item) => item.key === key);
};
